import { BorderRadius, Checkbox, Color, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FilterOptionRow = styled(Checkbox)`
  width: 100%;
  padding: ${Spacing.S12};
  border-radius: var(--border-radius-r-8, 8px);

  &:hover {
    background-color: var(--surface-neutral-soft-default, ${Color.Grey100});
  }
`

export const ChipTrigger = styled.button<{ isActive: boolean }>`
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  gap: var(--spacing-s-8, ${Spacing.S8});
  max-width: 240px;
  height: ${Spacing.S32};
  padding: var(--padding-p-4, ${Spacing.S4}) var(--padding-p-8, ${Spacing.S8});
  border: 1px solid var(--border-neutral-soft, ${Color.Grey200});
  border-radius: ${BorderRadius.RFull};
  background: var(--surface-neutral-base, ${Color.White});
  color: var(--content-black, ${Color.Black});
  font: inherit;
  font-size: var(--font-size-body-md, 14px);
  font-weight: var(--font-weight-600, 600);
  cursor: pointer;

  &:hover {
    background: var(--surface-neutral-soft-default, ${Color.Grey100});
  }
`

export const ChipLabel = styled.span`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export const PopoverCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: var(--border-radius-r-12, ${BorderRadius.R12});
  background: var(--surface-neutral-base, ${Color.White});
  overflow: hidden;
  ${getShadow('raisedStrong')};
`

export const PopoverBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s-8, ${Spacing.S8});
  padding: var(--padding-p-8, ${Spacing.S8});
`

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-s-8, ${Spacing.S8});
  padding: var(--padding-p-8, ${Spacing.S8});
  border-top: 1px solid var(--border-neutral-soft, ${Color.Grey100});

  & > * {
    flex: 1;
  }
`

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s-2, 2px);
  max-height: 240px;
  overflow-y: auto;
`

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s-8, ${Spacing.S8});
`

export const EmptyState = styled.div`
  padding: var(--padding-p-12, ${Spacing.S12});
`

export const RangeFieldsRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-s-4, ${Spacing.S4});
`

export const RangeField = styled.div`
  flex: 1;
  min-width: 0;
`

export const FiltersBarRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-s-8, ${Spacing.S8});
  margin-bottom: ${Spacing.S12};
`

export const FiltersBarSpacer = styled.div`
  flex: 1;
`

export const FilterTypeMenuPanel = styled.div`
  min-width: 256px;
  padding: var(--padding-p-8, ${Spacing.S8});
  border: 1px solid var(--border-neutral-soft, #d8dbdf);
  border-radius: var(--border-radius-r-12, 12px);
  background-color: var(--surface-neutral-base, #ffffff);
  box-shadow: 0 6px 16px rgb(0 0 0 / 16%);
`

export const FilterTypeMenuHeader = styled.div`
  padding: var(--padding-p-16, 16px) var(--padding-p-12, 12px) var(--padding-p-4, 4px);
  color: var(--content-neutral-medium, #6b7280);
  font-size: var(--font-size-body-md, 14px);
  font-weight: var(--font-weight-500, 500);
  line-height: var(--font-line-height-body-md, 20px);
`

export const FilterTypeMenuItem = styled.button`
  width: 100%;
  padding: var(--padding-p-12, 12px);
  border: none;
  border-radius: var(--border-radius-r-8, 8px);
  background: transparent;
  color: var(--content-black, #000000);
  font: inherit;
  font-size: var(--font-size-body-md, 14px);
  line-height: var(--font-line-height-body-md, 20px);
  text-align: left;
  cursor: pointer;
  appearance: none;

  &:hover {
    background: var(--surface-neutral-soft-default, #edeef1);
  }
`

export const AddFilterTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-s-8, ${Spacing.S8});
  height: ${Spacing.S32};
  padding: var(--padding-p-4, ${Spacing.S4}) var(--padding-p-8, ${Spacing.S8});
  border: 1px solid var(--border-neutral-soft, ${Color.Grey200});
  border-radius: ${BorderRadius.RFull};
  background: var(--surface-neutral-base, ${Color.White});
  color: var(--content-black, ${Color.Black});
  font: inherit;
  font-size: var(--font-size-body-md, 14px);
  font-weight: var(--font-weight-600, 600);
  cursor: pointer;

  &:hover {
    background: var(--surface-neutral-soft-default, ${Color.Grey100});
  }
`

export const ResetFiltersButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-s-8, ${Spacing.S8});
  height: ${Spacing.S32};
  padding: var(--padding-p-4, ${Spacing.S4}) var(--padding-p-8, ${Spacing.S8});
  border: none;
  border-radius: ${BorderRadius.RFull};
  background: transparent;
  color: var(--content-black, ${Color.Black});
  font: inherit;
  font-size: var(--font-size-body-md, 14px);
  font-weight: var(--font-weight-600, 600);
  cursor: pointer;

  &:hover {
    background: var(--surface-neutral-soft-default, ${Color.Grey100});
  }
`
